import React, { useState, useEffect } from 'react';
import { Box, AppBar, Toolbar, IconButton, Typography, CssBaseline, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import './DashboardLayout.css';
import { menuDefinitions } from '../../commun/Menu'; 

const drawerWidth = 260;

const DashboardLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('dashboard');
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:768px)');
  const userType = localStorage.getItem("userType");
  const isCvthequePage =
    location.pathname.includes('/add-talent') &&
    ['admin', 'commercial', 'agent'].includes(userType);
  const [collapsed, setCollapsed] = useState(isCvthequePage);
  useEffect(() => {
    setCollapsed(isCvthequePage);
  }, [location.pathname]);
  useEffect(() => {
    const path = location.pathname.split('/').pop() || 'dashboard';
    setActiveItem(path);
  }, [location]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Récupérer le label à afficher dans la TopBar
  const currentMenu = menuDefinitions.find(menu => menu.name === activeItem);
  const pageTitle = currentMenu ? currentMenu.label : 'Admin Panel';

  return (
    <Box className="dashboard-root">
      <CssBaseline />

      {isMobile && (
        <AppBar position="fixed" className="dashboard-appbar">
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" className="dashboard-title">
              {pageTitle}
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      <Sidebar
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        drawerWidth={drawerWidth}
        collapsed={collapsed} 
        onToggleCollapse={() => setCollapsed((prev) => !prev)}       />

<Box
  component="main"
  className={`dashboard-main ${collapsed ? 'collapsed-sidebar' : ''} ${isMobile ? 'mobile' : ''}`}
>
  {children}
</Box>

    </Box>
  );
};

export default DashboardLayout;
